import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/routes';
import { useAuth } from '@/contexts/AuthContext';

export function RequireAuth() {
  const { session, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation('auth');

  if (loading) {
    return (
      <div
        className="flex h-screen items-center justify-center"
        role="status"
        aria-label={t('callback.loading')}
      >
        <span className="h-8 w-8 animate-spin rounded-full border-2 border-brand border-t-transparent" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to={ROUTES.authSignIn} state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
